import { useState } from "react";
import { Button } from "react-bootstrap";
import StoreGeneralSettings from "./StoreGeneralSettings";
import StoreProdutsSettings from "./StoreProdutsSettings";
import StoreShippingSettings from "./StoreShippingSettings";
import StoreAccountPolicySettings from "./StoreAccountPolicySettings";

const TABS = [
  { key: "general", label: "General" },
  { key: "products", label: "Products" },
  { key: "shipping", label: "Shipping" },
  { key: "accountPrivacy", label: "Account & Privacy" },
];

const StoreSettingsManagement = () => {
  const [openModule, setOpenModule] = useState("general");

  const MODULES = {
    general: <StoreGeneralSettings />,
    products: <StoreProdutsSettings />,
    shipping: <StoreShippingSettings />,
    accountPrivacy: <StoreAccountPolicySettings />,
  };

  return (
    <div className="h-100 d-flex flex-column w-100">
      <div className="bg-white border-bottom py-2 px-3">
        <div className="hstack justify-content-between">
          <h6 className="fw-semibold m-0">Store Settings</h6>

          <div className="hstack gap-2">
            {TABS?.map(({ key, label }) => (
              <Button
                key={key}
                size="sm"
                variant={openModule === key ? "primary" : "outline-primary"}
                onClick={() => setOpenModule(key)}
              >
                {label}
              </Button>
            ))}
          </div>
        </div>
      </div>

      <div className="flex-grow-1 bg-light">
        {MODULES[openModule]}
      </div>
    </div>
  );
};

export default StoreSettingsManagement;
